<template>
   <v-app id="login">
      <v-content>
         <v-container class="background" fill-height fluid>
            <v-layout v-show="!forgotPasswordModal" class="first-layout slide-left">
               <v-flex xs12 style="border-bottom-right-radius: 40%; background: #094e93">
                  <div class="banner-content" style="margin: 10px 10px 10px 0;">
                     <h3 style="color: #fff; margin-bottom: -20px; margin-left: 10px;">Plataforma</h3>
                     <h1 style="color: #fff">Afiliados</h1>
                  </div>
               </v-flex>
            </v-layout>
            <v-layout v-show="!forgotPasswordModal" align-center justify-center>
               <v-flex lg5 md5 sm8 xs12>
                  <v-scale-transition origin="center center 0">
                     <v-sheet width="300" class="mx-auto">
                        <div class="layout column align-center" style="margin-bottom: 30px;">
                           <v-img :src="brandLogo" :contain="true" height="75" width="300"></v-img>
                        </div>
                        <v-form fast-fail @submit.prevent>
                           <v-text-field
                              ref="emailField"
                              v-model="formData.loginName"
                              :rules="[rules.required]"
                              value=""
                              label="Email"
                           ></v-text-field>

                           <v-text-field
                              :append-icon="show ? 'visibility' : 'visibility_off'"
                              :type="show ? 'text' : 'password'"
                              :rules="[rules.required]"
                              v-model="formData.password"
                              value=""
                              label="Senha"
                              @click:append="show = !show"
                           ></v-text-field>

                           <div style="margin-top: 30px;">
                              <v-btn type="submit" :loading="loading" @click="onLoginClick" block large style="border-radius: 25px; background: #094e93">
                                 Acessar
                              </v-btn>
                              <div style="margin-top: 20px; text-align: center;">
                                 <a v-on:click="forgotPasswordModal = true">Esqueceu a Senha?</a>
                              </div>
                           </div>
                        </v-form>
                        <div class="footer" style="align-items: center;">
                           <div>
                              <span style="font-size: 8pt;"> Copyright © 2024 |
                                 Desenvolvido por KemoSoft Tecnologia
                              </span>
                           </div>
                        </div>
                     </v-sheet>
                  </v-scale-transition>
               </v-flex>
            </v-layout>
            <v-layout v-show="forgotPasswordModal" align-center justify-center>
               <v-flex lg5 md5 sm8 xs12>
                  <v-scale-transition origin="center center 0">
                     <v-sheet width="300" class="mx-auto">
                        <div class="layout column align-center" style="margin-bottom: 30px;">
                           <v-img :src="brandLogo" :contain="true" height="100" width="300"></v-img>
                        </div>
                        <div style="margin-bottom: 15px !important;">
                           <span style="text-align: center;">Preencha os campos abaixo, uma senha temporária será enviada para o email cadastrado.</span>
                        </div>
                        <v-form fast-fail @submit.prevent>
                           <v-text-field
                              ref="emailField"
                              v-model="forgotPasswordData.email"
                              :rules="[rules.required]"
                              value=""
                              label="Email"
                           ></v-text-field>

                           <v-text-field
                              label="CPF/CNPJ"
                              v-mask="['###.###.###-##', '##.###.###/####.##']"
                              v-model="forgotPasswordData.federalId"
                              :rules="[rules.required]"
                              value=""
                           ></v-text-field>

                           <div style="margin-top: 30px;">
                              <v-btn type="submit" :loading="loading" @click="forgotPassword()" block large style="border-radius: 25px; background: #094e93">
                                 Gerar Senha
                              </v-btn>
                              <div style="margin-top: 20px; text-align: center;">
                                 <a v-on:click="forgotPasswordModal = false">Voltar para tela de Login</a>
                              </div>
                           </div>
                        </v-form>
                        <div class="footer" style="align-items: center;">
                           <div>
                              <span style="font-size: 8pt;">Copyright © 2024 |
                                 Desenvolvido por KemoSoft Tecnologia
                              </span>
                           </div>
                        </div>
                     </v-sheet>
                  </v-scale-transition>
               </v-flex>
            </v-layout>
            <v-layout v-show="forgotPasswordModal" class="first-layout slide-right">
               <v-flex xs12 style="border-bottom-left-radius: 40%; background: #094e93">
                  <div class="banner-content" style="margin: 10px 10px 10px 0;">
                     <h3 style="color: #fff; margin-bottom: -20px; margin-left: 10px;">Plataforma</h3>
                     <h1 style="color: #fff">Afiliados</h1>
                  </div>
               </v-flex>
            </v-layout>
         </v-container>
      </v-content>
      <div v-if="brandLoading" class="fullscreen-loading">
         <v-progress-circular color="#0096E8" indeterminate="indeterminate"></v-progress-circular>
      </div>
   </v-app>
</template>

<script>
export default {
  data: () => ({
     show: false,
     init: false,
     loading: false,
     validateRules: false,
     forgotPasswordModal: false,

     brandName: '',
     brandLogo: '',
     brandLoading: false,

     formData: {
        loginName: '',
        password: ''
     },

     forgotPasswordData: {
        email: '',
        federalId: '',
     },
     rules: {
        required: (value) => !!value || 'Por favor, preencha esse campo.'
     }
  }),

  created() {
     this.getBrand();
     if (location.origin === 'https://afiliados.homeofficeconfianca.com.br') {
        this.brandLogo = 'https://res.cloudinary.com/consigmais/image/upload/c_scale,w_350/logos/logo_home_office_confian%C3%A7a_dark.png';
     }
  },

  mounted() {
     setTimeout(() => (this.init = true), 100);
  },

  methods: {
     async getBrand() {
        this.brandLoading = true;

        await this.$api.dataService.getPublicData('getBrandSimple', {})
           .then((res) => {
              this.brandName = res.brandName;
              this.brandLogo = res.brandLogo;
              document.title = this.brandName;
              console.log(res);
           })
           .catch((err) => {
              //
           });

        this.brandLoading = false;
     },

     closeForgotPasswordModal() {
        this.forgotPasswordModal = false;
        this.forgotPasswordData.email = '';
        this.forgotPasswordData.federalId = '';
     },

     forgotPassword() {
        this.$api.authService
           .forgotPasswordAffiliate({
              mainEmail: this.forgotPasswordData.email.toLowerCase().trim(),
              federalId: this.forgotPasswordData.federalId.replace(/\D/g, '').trim()
           })
           .then(() => {
              this.closeForgotPasswordModal();
              this.forgotPasswordModal = false;
              this.$notifyUser({
                 message: 'Email enviado com sucesso!',
                 type: 'success'
              });
           })
           .catch((err) => {
              this.$notifyUser({
                 type: 'error',
                 message: err ? err.msg : 'Ocorreu um erro ao enviar o email!'
              });
           });
     },

     onLoginClick() {
        this.loading = true;

        if (!this.formData.loginName || !this.formData.password) {
           this.loading = false;
           this.$notifyUser({
              message: 'Favor informar os 2 campos.',
              type: 'error'
           });
           return;
        }

        this.formData.loginName = this.formData.loginName.toLowerCase().trim();
        this.formData.password = this.formData.password.trim();

        this.$api.authService
           .loginAffiliate(this.formData)
           .then(() => (this.init = false))
           .finally(() => (this.loading = false));
     }
  }
};
</script>

<style lang="css" scoped>
@media only screen and (max-width: 757px) {
   .first-layout {
      display: none;
   }
}

.h1 {
   font-family: Montserrat, sans-serif;
}

.banner-content {
   padding: 15px 0 0 15px;
}

#login {
   background-color: #F9F9F9;
}

.clear-bg {
   border-radius: 10px;
   color: #dadada !important;
   background-color: #ffffff !important;
}

.v-btn {
   font-family: Montserrat, sans-serif;
   color: #ffffff !important;
   border-radius: 5px;
   margin: 0 0.5rem 0 0.5rem;
}

.fullscreen-loading {
   width: 100vw;
   height: 100vh;
   position: absolute;
   top: 0;
   left: 0;
   background-color: #EFEFEF;
   z-index: 2000;
   display: flex;
   justify-content: center;
   align-items: center;
}

.background {
   padding: 0 !important;
}

.footer {
   position: absolute;
   bottom: 8px;
}
</style>


// WEBPACK FOOTER //
// src/pages/Login.vue